import { createApiRef } from '@backstage/core-plugin-api';
import { EpDevPPluginIds } from './APIplugins/ep-devp-common';
import { IEpDevPConsumerAppsApiClient } from './APIplugins/ep-devp-consumer-apps-common';
import { IEpDevPConsumerProductsApiClient } from './APIplugins/ep-devp-consumer-products-common';


export const epDevPConsumerAppsApiRef = createApiRef<IEpDevPConsumerAppsApiClient>({
  id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}.api-ref`
});

export const epDevPConsumerProductsApiRef = createApiRef<IEpDevPConsumerProductsApiClient>({
  id: `${EpDevPPluginIds.EpDevPConsumerAppsPluginId}.${EpDevPPluginIds.EpDevPConsumerProductsPluginId}.api-ref`
});